var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNeurolaboLogoFull(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 274.854,
    height: 58.159,
    viewBox: "0 0 304.854 58.159",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-21.146 -21)"
  }, /*#__PURE__*/React.createElement("text", {
    transform: "translate(90 63.079)",
    fill: "#b0bddf",
    fontSize: 33,
    fontFamily: "CenturyGothic, Century Gothic",
    letterSpacing: "0.1em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Neuro"), /*#__PURE__*/React.createElement("tspan", {
    y: 0,
    fill: "#5f8aff"
  }, "Labo")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(35.068 34.295)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1081.274,1120.2H1070.2v-17.69l9.3,14.853Z",
    transform: "translate(-1068.71 -1088.632)",
    fill: "#bfccf0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1081.319,1120.225h-11.147v-17.8l.046.074Zm-11.1-.05h11.007l-11.007-17.578Z",
    transform: "translate(-1068.71 -1088.632)",
    fill: "#004562"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1067.308,960.45a1.543,1.543,0,0,0-1.544,1.544v15.67l-9.3-14.84-1.487-2.373Z",
    transform: "translate(-1054.976 -960.45)",
    fill: "#bfccf0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1054.931,960.425h12.377v.05a1.52,1.52,0,0,0-1.519,1.518V977.75l-.046-.074Zm11.983.05h-11.893l10.718,17.1V961.994A1.571,1.571,0,0,1,1066.914,960.475Z",
    transform: "translate(-1054.976 -960.45)",
    fill: "#004562"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1223.19,1267.78v.16a1.385,1.385,0,0,1-1.385,1.384h-.159A1.544,1.544,0,0,0,1223.19,1267.78Z",
    transform: "translate(-1205.364 -1237.757)",
    fill: "#5fbdff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1223.19,961.834v.159a1.543,1.543,0,0,0-1.544-1.544h.159A1.384,1.384,0,0,1,1223.19,961.834Z",
    transform: "translate(-1205.364 -960.45)",
    fill: "#5fbdff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1223.19,961.834v.159a1.543,1.543,0,0,0-1.544-1.544h.159A1.384,1.384,0,0,1,1223.19,961.834Z",
    transform: "translate(-1205.364 -960.45)",
    fill: "#5fbdff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1223.19,1267.78v.16a1.385,1.385,0,0,1-1.385,1.384h-.159A1.544,1.544,0,0,0,1223.19,1267.78Z",
    transform: "translate(-1205.364 -1237.757)",
    fill: "#5fbdff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1240.9,986.174v4.8a1.047,1.047,0,0,1-1.046,1.046h-16.58a1.385,1.385,0,0,0,1.384-1.384v-28.8a1.384,1.384,0,0,0-1.384-1.384h6.313a.712.712,0,0,1,.712.712v23.966h9.555A1.047,1.047,0,0,1,1240.9,986.174Z",
    transform: "translate(-1206.835 -960.45)",
    fill: "#5f8aff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1239.856,992.043h-16.58v-.05a1.361,1.361,0,0,0,1.359-1.359v-28.8a1.361,1.361,0,0,0-1.359-1.359v-.05h6.313a.738.738,0,0,1,.737.737V985.1h9.53a1.073,1.073,0,0,1,1.071,1.071v4.8A1.073,1.073,0,0,1,1239.856,992.043Zm-16.207-.05h16.207a1.022,1.022,0,0,0,1.021-1.021v-4.8a1.022,1.022,0,0,0-1.021-1.021h-9.58V961.162a.688.688,0,0,0-.687-.687h-5.94a1.412,1.412,0,0,1,1.037,1.359v28.8A1.412,1.412,0,0,1,1223.649,991.993Z",
    transform: "translate(-1206.835 -960.45)",
    fill: "#004562"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M29.2,2A27.214,27.214,0,0,0,4.135,18.542,26.978,26.978,0,0,0,9.963,48.224a27.249,27.249,0,0,0,38.468,0A27.088,27.088,0,0,0,29.2,2m0-2A29.08,29.08,0,1,1,0,29.079,29.138,29.138,0,0,1,29.2,0Z",
    transform: "translate(21.146 21)",
    fill: "#90aeff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNeurolaboLogoFull);
export default __webpack_public_path__ + "static/media/neurolabo-logo-full.3df20b40a57aa78b26b04d83e3d01f20.svg";
export { ForwardRef as ReactComponent };